export const config = {
  apiUrl: `${process.env.REACT_APP_API_URL}`,
  api: `${process.env.REACT_APP_API}`,
  cdnUrl: `${process.env.REACT_APP_CDN_URL}`,
  logRocketId: process.env.REACT_APP_LOG_ROCKET_ID, 
};



export const PREFERRED_TIME_LIST = [
  {
    id: 'balanced',
    title: 'Balanced',
  },
  {
    id: 'early',
    title: 'Early Games',
  },
  {
    id: 'late',
    title: 'Late Games',
  },
]

export const PERMISSIONS = {
  LEAGUES: 'leagues',
  REVENUE: 'revenue',
  LEAGUE_MODIFICATIONS: 'league_modifications',
  TEAM_MODIFICATIONS: 'team_modifications',
  EVENTS: 'events',
  SETTINGS: 'settings',
  USERS: 'users',
  MASS_EMAIL: 'mass_email',
  MASS_TEXT: 'mass_text',
  REFUND_FORFEIT: 'refund_forfeit', 
}

export const REGISTERED_THROUGH_MULBERRY = 'M'; 
export const REGISTERED_THROUGH_CLEVELAND = 'C';